import { Component } from '@angular/core';

import screenfull from 'screenfull';

@Component({
  selector: 'cube-fullscreen',
  templateUrl: './fullscreen.component.html',
  standalone: false,
})
export class FullscreenComponent {
  screen = screenfull;

  toggleFullscreen(): void {
    if (this.screen.isEnabled) this.screen.toggle();
  }
}
